import { FC } from 'react';
import { IRTERenderElementProps } from '../../../../../../RTEEditable.interfaces';

export const TableRowElement: FC<IRTERenderElementProps> = (props) => {
  const { children } = props;
  const attributes = props.attributes ?? {};

  return <tr {...attributes}>{children}</tr>;
};
